export function openWhatsappMessage(phoneNumber: string): void {
    phoneNumber = phoneNumber.includes('+') ? phoneNumber.slice(1) : phoneNumber;
    window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}`, '_blank');
}
